var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classes},[_vm._v(_vm._s(_vm._f("formatNumberAndDecimal")(_vm.value))+" USDT")])
}
var staticRenderFns = []

export { render, staticRenderFns }